module.exports = __webpack_public_path__ + "static/media/568JamesPBrawleyDrNW_2018-06-12_102.e3f4a04f.jpg";